import { Eye } from "lucide-react";

// SPA port of /app/admin/analytics/_components/TopAssetsList.tsx.

export function TopAssetsList({
  assets,
}: {
  assets: Array<{ title: string; type: string; views: number }>;
}) {
  if (assets.length === 0) {
    return (
      <p className="rounded-md border border-dashed bg-muted/30 px-3 py-6 text-center text-xs text-muted-foreground">
        No content views yet.
      </p>
    );
  }
  const max = Math.max(...assets.map((a) => a.views), 1);
  return (
    <ul className="space-y-3">
      {assets.map((a, i) => (
        <li key={i}>
          <div className="mb-1 flex items-baseline justify-between gap-2">
            <span className="truncate text-sm font-medium">{a.title}</span>
            <span className="inline-flex items-center gap-1 text-[11px] tabular-nums text-muted-foreground">
              <Eye className="h-3 w-3" />
              {a.views}
            </span>
          </div>
          <div className="h-1.5 overflow-hidden rounded-full bg-muted">
            <div
              className="h-full rounded-full bg-accent"
              style={{ width: `${(a.views / max) * 100}%` }}
            />
          </div>
        </li>
      ))}
    </ul>
  );
}
